<template>
  <div class="shadow-box-title-description">
    <ShadowBox
      v-if="title"
      class="shadow-box"
      :class="{center: titleCenter}"
      opacity="_60"
    >
      <span class="text">{{title}}</span>
    </ShadowBox>
    <slot></slot>
  </div>
</template>

<script>
import ShadowBox from '@/components/atoms/ShadowBox.vue';

export default {
  name: 'ShadowBoxTitleDescription',

  components: {
    ShadowBox,
  },

  props: {
    title: {
      type: String,
    },
    titleCenter: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.shadow-box-title-description{
  .shadow-box{
    display: flex;
    width: 100%;
    min-height: 30px;
    padding: 6px 0;
    // border-bottom: solid 1px $yellow;
    background-color: $white;
    justify-content: flex-start;
    .text{
      font-family: $notoSansJP;
      font-size: 20px;
      font-weight: bold;
      color: $black;
      display: flex;
      padding: 4px 0;
      border-radius: 100px;
    }
  }
  .center {
    justify-content: center;
  }
}
</style>
